import { useState } from 'react';
import { useQuery} from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import qs from 'query-string';

interface CrmListProps  {
  company: number;
  pageNo: number;
  pageSize: number;
}
const useCrmList = (params: CrmListProps) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [crmList, setCrmList] = useState<CrmListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */

  const searchParams = qs.parse(location.search);
  const { isLoading } = useQuery(
    [endpoints.crm.list, params],
    () =>
      fetcher.crm.postCrmList({
        pageNo: Number(params.pageNo) || 1,
        pageSize: Number(params.pageSize) || INIT_PAGESIZE,
        company: params.company || 0,              
      }),
    {
      onSuccess: (res: CrmListResDto) => {
        switch (res.code) {
          case 200:
            setCrmList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, crmList, searchResult  };
};

export default useCrmList;
